import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEYS = {
  admin: "ssm_admin_token",
  actor: "ssm_actor_token",
  judge: "ssm_judge_token",
};

export const getToken = (role = "admin") => localStorage.getItem(TOKEN_KEYS[role]);
export const setToken = (token, role = "admin") => localStorage.setItem(TOKEN_KEYS[role], token);
export const clearToken = (role = "admin") => localStorage.removeItem(TOKEN_KEYS[role]);

export const api = axios.create({ baseURL: API });

// Two separate instances for admin vs portal
export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = getToken("admin");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const eid = localStorage.getItem("ssm_event_id");
  if (eid) cfg.headers["X-Event-Id"] = eid;
  return cfg;
});

export const portalApi = axios.create({ baseURL: API });
portalApi.interceptors.request.use((cfg) => {
  const t = getToken("actor");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const judgeApi = axios.create({ baseURL: API });
judgeApi.interceptors.request.use((cfg) => {
  const t = getToken("judge");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const formatApiError = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(d);
};

export const fileUrl = (fileId, opts) => fileId ? `${API}/files/${fileId}${opts && opts.thumb ? "?thumb=1" : ""}` : null;
